// Display helpers for alerts (formatting only — no alert rules here), in the UI language.
import i18n, { locale } from '@/i18n';
import { nf } from '@/lib/format';
import type { FlowKind } from '@/types';

const compact = (opts: Intl.NumberFormatOptions) => new Intl.NumberFormat(locale(), { notation: 'compact', compactDisplay: 'short', maximumFractionDigits: 1, ...opts });
/** 148,7 млн $ · $148.7M · 148,7 Mio. $ */
export const money = (n: number) => compact({ style: 'currency', currency: 'USD', currencyDisplay: 'narrowSymbol', maximumFractionDigits: n >= 1e8 && n < 1e9 ? 0 : 1 }).format(n);
/** Bot's threshold button label: $5M+ (the bot's own notation in every language) */
export const thrLabel = (n: number) => `$${n / 1e6}M+`; // i18n-allow: the bot's button notation
/** 38 000 ETH · 1,1 млн SOL · 1.1M SOL */
export const amount = (n: number, token: string) => `${n >= 1e6 ? compact({}).format(n) : nf(n)} ${token}`;
export const signedLevel = (l: number) => (l === 0 ? '±0' : `${l > 0 ? '+' : '−'}${Math.abs(l)}%`);

/** Flow wording as in the bot's messages + Orca's caveat (never a guess as a fact). */
export const FLOW = new Proxy({} as Record<FlowKind, { label: string; hint: string; note: string }>, {
  get: (_, k) => (typeof k !== 'string' || !['inflow', 'outflow', 'exchange_to_exchange', 'wallet_transfer'].includes(k) ? undefined : {
    label: i18n.t(`alerts:flow.${k as FlowKind}.label`),
    hint: i18n.t(`alerts:flow.${k as FlowKind}.hint`),
    note: i18n.t(`alerts:flow.${k as FlowKind}.note`),
  }),
});
